<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import Swal from "sweetalert2";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import procedimientosAPI from "../../../services/standards/procedimientos/procedimientosAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,
      search: "",

      lista: [],
      loading: true,

      file: null,
      file2: null,

      loading1: true,

      procedimientoId: null,
      procedimientos: {
        document: null,
        evidence: null,
        procedures_and_protocols_id: this.procedimientoId,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      submitted: false,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },


    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to send notification to SST user and SST company.
   * The sendNotification method import is required.
   * @param {Number} messageID - The message ID that will be associated to notification.
   * @param {Number} itemID - The item ID that will be associated to notification.
   * @param {Boolean} user - The user that will e associated to notification.
   * @return {Boolean} True if the notification is sent, false if not.
   */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 9)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getShow() {
      procedimientosAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.procedimientos = {
            document: response.data.document,
            evidence: response.data.evidence,
            procedures_and_protocols_id: response.data.id,
            companies_id: response.data.companies_id,
          };
          this.procedimientoId = response.data.id
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      procedimientosAPI
        .getAllE(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.loading = false;
          let identification = response.data.data;
          this.lista = identification;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadFile2() {
      this.file2 = this.$refs.file.files[0];
    },

    goBack() {
      this.$router.go(-1);
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getFile2(file2) {
      const name = file2.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.procedimientos.document)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.3/${this.procedimientoId}/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.3/${this.procedimientoId}/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.procedimientos.document = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        let name = '';

        if (this.file2 === null) {
          name = this.getFile2(this.procedimientos.evidence)
        } else {
          name = this.file2.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.3/${this.procedimientoId}/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.3/${this.procedimientoId}/${this.$route.params.id}/${name}`;
        }

        if (this.file2 === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file2);
          if (result) {
            this.procedimientos.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      this.submitted = true
      this.loading1 = true
      let response = await this.uploadDocument();
      let response2 = await this.uploadDocument2();
      if (response && response2) {
        procedimientosAPI
          .updateEvidencia(this.procedimientos, this.$route.params.id)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 47,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(26, 9, true);
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar, error carga documentos!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },
  },

  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="loading1">
          <div class="card">
            <div class="card-body">
              <form class="form-group px-2" @submit.prevent="save">
                <div class="row px-3">
                  <div class="col-12 text-right m-b-0">
                    <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                      <i class="fas fa-arrow-left"></i>
                    </div>
                    <b-tooltip target="back" placement="left">
                      Volver
                    </b-tooltip>
                  </div>
                </div>
                <hr />
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Subir documento" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="procedimientos.document
                        ? getFile(procedimientos.document)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir evidencia de socialización" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file2" ref="file2"
                      name="file2" browse-text="Buscar" :placeholder="procedimientos.evidence
                        ? getFile(procedimientos.evidence)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file2" @change="uploadFile2"
                      v-on:change="uploadFile2"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 pt-2">
                  <button type="submit" :disabled="submitted" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
